import {
  BffApiUpdateItemError,
  Currencies,
  UpdateItemGqlStatus
} from '../../../../types';

import {
  ChangeCurrencyInvoiceCacheKeys,
  ChangeCurrencyInvoiceGqlQuery,
  InvoiceID,
  InvoiceNanoID,
  InvoiceUUID
} from '../../invoicesTypes';
import { CurrencyRateID } from '../../../currencyRates/currencyRatesTypes';

import { CACHE_INVOICE_CHANGE_CURRENCY_QUERY } from '../../queries/cacheInvoiceChangeCurrency.query';

import { useCacheUpdateQuery } from '../../../common/reactQuery/hooks/useCacheUpdateQuery';

interface CacheInvoiceChangeCurrencyOptions {
  query?: ChangeCurrencyInvoiceGqlQuery;
  cacheKeys?: ChangeCurrencyInvoiceCacheKeys;
}

export interface CacheInvoiceChangeCurrencyInput {
  uuid: InvoiceID | InvoiceNanoID | InvoiceUUID;
  currencyRateId?: CurrencyRateID;
  selectedCurrency?: Currencies;
}

export interface CacheInvoiceChangeCurrencyResponse {
  invoiceChangeCurrency: {
    status: UpdateItemGqlStatus;
  };
}

export type CacheInvoiceChangeCurrencyError = BffApiUpdateItemError;

const action = 'invoiceChangeCurrency';

function useCacheInvoiceChangeCurrency<
  CacheInvoiceChangeCurrencyRecordType = unknown
>({
  query = CACHE_INVOICE_CHANGE_CURRENCY_QUERY,
  cacheKeys
}: CacheInvoiceChangeCurrencyOptions = {}) {
  const {
    updateCacheQuery,
    updateCacheQueryData,
    updateCacheQueryError,
    updateCacheQueryErrorMessage,
    updateCacheQueryLoading,
    updateCacheQueryReset
  } = useCacheUpdateQuery<
    CacheInvoiceChangeCurrencyInput,
    CacheInvoiceChangeCurrencyResponse,
    CacheInvoiceChangeCurrencyError,
    CacheInvoiceChangeCurrencyRecordType
  >({ action, query, cacheKeys });

  return {
    changeCurrency: updateCacheQuery,
    changeCurrencyData: updateCacheQueryData,
    changeCurrencyError: updateCacheQueryError,
    changeCurrencyErrorMessage: updateCacheQueryErrorMessage,
    changeCurrencyLoading: updateCacheQueryLoading,
    changeCurrencyReset: updateCacheQueryReset
  };
}

export default useCacheInvoiceChangeCurrency;
